// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__q-+N-","text":"Hero_text__2nW2o"};